import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector } from '@angular/core';
import { ComponentRef } from '@angular/core';
import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal';
import { LoadingComponent } from '../components/loading/loading.component';


import { Store } from '@ngrx/store';
import { RestState } from '../store/reducers/rest.reducer';
import { EndRequest, BeginRequest, ResetCounter } from '../store/actions/rest.actions';

@Injectable({ providedIn: 'root' })
export class LoadingService {

  // 1. Reference to our Portal.
  //    This is the portal we'll use to attach our LoadingSpinnerComponent.
  private loadingSpinnerPortal: ComponentPortal<LoadingComponent>;

  // 2. Reference to our Portal Host.
  //    We use DOMPortalHost as we'll be using document.body as our anchor.
  private bodyPortalHost: DomPortalOutlet;

  private loadingCmpRef: ComponentRef<LoadingComponent>;

  // 3. Inject the dependencies needed by the DOMPortalHost constructor
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
    private store: Store<RestState>) {

    // 4. Create a Portal based on the LoadingSpinnerComponent
    this.loadingSpinnerPortal = new ComponentPortal(LoadingComponent);

    // 5. Create a PortalHost with document.body as its anchor element
    this.bodyPortalHost = new DomPortalOutlet(
      document.body,
      this.componentFactoryResolver,
      this.appRef,
      this.injector);
  }

  reveal() {
    // 6. Attach the Portal to the PortalHost.
    if (!this.bodyPortalHost.hasAttached())
      this.loadingCmpRef = this.bodyPortalHost.attach(this.loadingSpinnerPortal);
    else {
      if (this.loadingCmpRef) {
        this.loadingCmpRef.instance.reset();
      }
    }
  }

  hide() {
    // 7. Detach the Portal from the PortalHost
    if (this.bodyPortalHost.hasAttached()) {
      this.bodyPortalHost.detach();
    }
  }

  // manually show spin
  showSpin() {
    this.store.dispatch(new ResetCounter());
    this.store.dispatch(new BeginRequest('spin'));
    this.reveal();
  }

  // manually show progress
  setProgress(progress: number) {
    this.store.dispatch(new ResetCounter());
    if (progress > 0 && progress <= 100) {
      this.store.dispatch(new BeginRequest('loading', true, null, progress));
    }
    else {
      this.hide();
    }
  }
}
